<ng-container [ngSwitch]="info.type" *ngIf="info && isVisible">
  <ng-container *ngSwitchCase="'list'">
    <lm-list
        [listUrlInfo]="info.urlInfo"
        [listSpec]="info.spec"
        (drillAroundEvent)="onDrillAround($event)"
    ></lm-list>
  </ng-container>

  <ng-container *ngSwitchCase="'form'">
    <lm-form
        [formUrlInfo]="info.urlInfo"
        [formSpec]="info.spec"
        (drillAroundEvent)="onDrillAround($event)"
    ></lm-form>
  </ng-container>

  <ng-container *ngSwitchCase="'unknown'">
    <div class="lm-is-indent field">
      <div *ngIf="false" class="fieldset-title">{{info.dataView.representativeText}}</div>
      <div class="label">{{ 'DrillAroundErrorMsg' | translate: info.drillAction.drillName }}</div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'pdf'">
    <div class="lm-is-indent field">
      <div class="fieldset-title">{{info.dataView.representativeText}}</div>
      <a soho-hyperlink
         class="lm-hyperlink"
         href="{{info.drillAction.drillUrl}}"
         target="_blank">{{info.drillAction.drillName}}</a>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'record'">
      <lm-drill-point-list
          [info]="info"
          [selectedNode]="selectedNode"
          (drillPointSelected)="onDrillActionSelected($event)"
      ></lm-drill-point-list>
  </ng-container>
</ng-container>
